// extracted by mini-css-extract-plugin
module.exports = {"FinishedQuiz":"FinishedQuiz_FinishedQuiz__D-CkC","success":"FinishedQuiz_success__jBBc5","error":"FinishedQuiz_error__KSdom"};